// Real payment service for production use
// const NGROK_API_URL = 'https://fc517eed738a.ngrok-free.app/api';
const LOCAL_API_URL = 'http://localhost:3001/api';
const API_BASE_URL = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : LOCAL_API_URL;

export const createPaymentIntent = async (productData) => {
  const requestBody = {
    amount: productData.amount, // amount in cents
    currency: productData.currency || 'gbp',
    metadata: {
      productId: productData.productId,
      productName: productData.productName,
      quantity: productData.quantity || 1,
      customerEmail: productData.customerEmail || '',
      customerName: productData.customerName || '',
      customerPhone: productData.customerPhone || '',
      customerAddress: JSON.stringify(productData.customerAddress || {}),
      // Add personalization data if available
      isPersonalized: productData.isPersonalized || false,
      personalizationMessage: productData.personalizationMessage || '',
      // Send base64 images - backend will upload to Vercel Blob
      personalizationImages: productData.personalizationImages
        ? JSON.stringify(productData.personalizationImages.map(img => ({
            url: img.url,
            name: img.name,
            type: img.type
          })).filter(Boolean))
        : '[]',
      collectionDate: productData.collectionDate || '',
    }
  };

  // Try ngrok first, fallback to localhost
  const urlsToTry = [API_BASE_URL, LOCAL_API_URL];
  
  for (const baseUrl of urlsToTry) {
    try {
      console.log(`Attempting payment intent creation with: ${baseUrl}`);
      
      const response = await fetch(`${baseUrl}/create-payment-intent`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(`Payment intent created successfully with: ${baseUrl}`);
      
      return {
        clientSecret: data.clientSecret,
        amount: productData.amount,
        currency: productData.currency,
      };
    } catch (error) {
      console.warn(`Failed with ${baseUrl}:`, error.message);
      
      // If this is the last URL and it failed, throw the error
      if (baseUrl === urlsToTry[urlsToTry.length - 1]) {
        console.error('All payment endpoints failed');
        throw new Error(`Payment service unavailable. Tried: ${urlsToTry.join(', ')}`);
      }
      
      // Continue to next URL
      continue;
    }
  }
};

// Mock function to confirm payment - In production, this would be handled by Stripe
export const confirmPayment = async (paymentData) => {
  try {
    // Simulate processing time
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    // In production, Stripe handles this automatically
    return {
      success: true,
      paymentIntentId: `pi_${Date.now()}`,
      status: 'succeeded',
    };
  } catch (error) {
    console.error('Error confirming payment:', error);
    throw new Error('Payment confirmation failed');
  }
};

// Helper function to format currency
export const formatCurrency = (amount, currency = 'gbp') => {
  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currency.toUpperCase(),
  });
  
  return formatter.format(amount / 100);
};
